export enum SplashAnimationType {
    FadeOut = "fade-out"
}
